import React from 'react'
import SelectField from '../input/SelectField'
import { Typography } from '@mui/material'
export const optionListGender  = [
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' }
];

export const SelectFieldGender = ({ id, onChange, name, value, error, disabled, isPreview }) => {
  if (isPreview) {
    return (
      <Typography>{optionListGender.find((op) => op.value === value)?.label}</Typography>
    )
  }

  return (
    <SelectField
      id={id}
      error={error}
      helperText={error}                    
      value={value || ''}
      name={name}
      onChange={onChange}      
      options={optionListGender}
      placeholder="Choose a gender"
      disabled={disabled}
    />  
  )
}
